<template>
  <div style="padding-top: 30px"  v-if="seznamZascitaVarnost.length > 0">
    <div style="padding-bottom: 30px">
      <p class="navadno-besedilo vrstica-stil">
        Varnostni paket Panda vas varuje pred vsakodnevnimi grožnjami, s katerimi se vsi uporabniki srečujemo
        na internetu. <br>
        Zagotavljajo najvišji možen nivo zaščite pred naprednimi grožnjami, zavaruje naprave na vseh OS,
        varuje domače omrežje, shranjena gesla, šifrira fotografije, itd. <br>
        Še več informacij najdete <a :href=varnostniPaketPanda class="primarna-barva">tukaj</a>.
      </p>
      <p class="navadno-besedilo" style="padding-top: 20px">
        <b>
          Za vsak računalnik je potrebna svoja licenca, le-ta pa se aktivira takoj po naročilu.
        </b>
      </p>
    </div>
    <div class="postavitev-paketi-zascitna-oprema" v-loading="nalaganjePaketovVarnostneZascite">
      <div class="postavitev-paketov-zascita-varnost" v-for="posamezenPaketZascitaVarnost in seznamZascitaVarnost">
        <div>
          <div class="postavitev-naziva">
            <b>
              {{ posamezenPaketZascitaVarnost.naziv.toUpperCase() }}
            </b>
          </div>
          <div class="podcrtan-naziv-zascita-varnost"/>
          <br/>
          <info-komponenta-opis-panda-paketa :OpisiPaketa="posamezenPaketZascitaVarnost.opis" />
          <div class="izpis-cena-zascita-varnost">
            {{ posamezenPaketZascitaVarnost.cenaDDV }} € / mesec
          </div>
          <div>
            <div>
              <OrderButton
                :services="[{
                  serviceId: posamezenPaketZascitaVarnost.idStoritevVrstaIzbira,
                  quantity: kolicinaZaNarocanje,
                  terminationPointId: Number.parseInt(izbranPrikljucek),
                  additionalData: [{key: 'email', value: emailUporabnika}]
                }]"
                @orderConfirmed="OsveziPodatke()"
                class="postavitev-gumb-narocanje inline-button"
                :service-name="posamezenPaketZascitaVarnost.naziv"
                select-quantity-text="Izberite količino licenc in vnesi email predal"
                custom-notify-text-button="NAROČI"
                :custom-notify-text="`Za naročilo ${posamezenPaketZascitaVarnost.naziv} prosimo vpišite elektronski naslov, na katerega vam bomo poslali licenco:`"
                :select-quantity-in-dialog="true">
                NAROČI
                <template slot="additionalDataInputs">
                  <div class="mb-5 panda-dialog-input">
                    <strong>
                      Elektronski naslov
                    </strong>
                    <el-input
                      class="panda-narocilo"
                      style="width: 250px;"
                      placeholder="Vnesite elektronski naslov"
                      v-model="emailUporabnika"
                      type="text"/>
                  </div>
<!--                  <div class="mb-5 panda-dialog-input">-->
<!--                    <strong>-->
<!--                      Število licenc-->
<!--                    </strong>-->
<!--                    <el-select style="width: 250px;" v-model="kolicinaZaNarocanje" class="kolicina-narocanje panda-narocilo">-->
<!--                      <el-option-->
<!--                        v-for="option in numbers"-->
<!--                        :value="option"-->
<!--                        :label="option"-->
<!--                        :key="option">-->
<!--                      </el-option>-->
<!--                    </el-select>-->
<!--                  </div>-->
                </template>
              </OrderButton>
            </div>
          </div>
        </div>
      </div>
      <div class="postavitev-info-varnost">
        <info-komponenta-varnostna-zascita class="" v-if="steviloPaketov < 4"/>
      </div>
    </div>
    <div>
      <info-komponenta-varnostna-zascita class="odmik-zgoraj" v-if="steviloPaketov > 3"/>
    </div>
    <div style="padding-top: 30px" v-if="seznamNarocenihLicenc.length > 0" v-loading="pridobivanjeSezanamLicenc">
      <div style="padding-top: 40px; padding-bottom: 40px">
        <hr class="hr-stil"/>
      </div>
      <div>
        <p class="open-sans-20pt">
          Seznam licenc
        </p>
      </div>
      <div v-show="prikazTabele === '1'">
        <el-table :data="seznamNarocenihLicenc"
                  :row-key="row => row.idPanda"
                  :expand-row-keys="expandRowKeys"
                  @expand-change="IzbiraVrsticeZaPrikazPodatkov">
          <el-table-column
            prop="naziv"
            label="Tip licence">
          </el-table-column>
          <el-table-column
            prop="kolicina"
            label="Količina">
          </el-table-column>
          <el-table-column
            prop="formatiranDatum"
            label="Datum nakupa">
          </el-table-column>
          <el-table-column width="200px">
            <template slot-scope="scope">
              <OrderButton
                @orderConfirmed="OsveziPodatke()"
                :services="[{
                      serviceId: scope.row.idStoritevVrstaIzbira,
                      quantity: 0,
                      terminationPointId: Number.parseInt(izbranPrikljucek),
                      additionalData: [{key: 'pandaId', value: scope.row.idPanda}]
                    }]"
                class="inline-button"
                :service-name="scope.row.naziv">
                <template slot="buttonOverride">
                  <a style="color: #080809">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev/Icon-awesome-trash-alt.png">
                    <b>
                      ODJAVI LICENCO
                    </b>
                  </a>
                </template>
              </OrderButton>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="padding-top: 20px">
                <el-form label-width="155px" :label-position="formaOrientacija">
                  <el-form-item label="Količina:" v-if="urejanjeKolicine.indexOf(scope.row.idPanda) === -1">
                    {{ scope.row.kolicina }}
<!--                    <img-->
<!--                      style="cursor: pointer"-->
<!--                      src="/static/img/dashboard/Icon-ionic-md-settings-grey.png"-->
<!--                      @click="PrikazUrejanjeKolicine(scope.row.idPanda)">-->
                  </el-form-item>
                  <el-form-item label="Količina:" v-else>
                    <el-input v-model.number="kolicinaIzbraneVrstice" class="velikost-input"/>
                    <OrderButton
                      @orderConfirmed="OsveziPodatke()"
                      :services="[{
                        serviceId: scope.row.idStoritevVrstaIzbira,
                        quantity: kolicinaIzbraneVrstice,
                        terminationPointId: Number.parseInt(izbranPrikljucek),
                        additionalData: [{key: 'pandaId', value: scope.row.idPanda}]
                      }]"
                      class="inline-button"
                      :service-name="'spremembo količine za naročeno storitev' + scope.row.naziv">
                      <template slot="buttonOverride">
                        <div class="stil-gumb-preklici">
                          <el-button type="primary" class="gumb-potrdi">
                            SHRANI
                          </el-button>
                        </div>
                      </template>
                    </OrderButton>
                    <a class="stil-gumb-preklici" @click="PrikazUrejanjeKolicine(scope.row.idPanda)"
                       type="primary">
                      PREKLIČI
                    </a>
                  </el-form-item>
                  <el-form-item label="Datum nakupa:">
                    {{ scope.row.formatiranDatum }}
                  </el-form-item>
                  <el-form-item label="Kontaktna oseba:" v-if="urejanjeEmaila === false">
                    {{ scope.row.email }}
                    <img
                        style="cursor: pointer"
                        src="/static/img/dashboard/Icon-ionic-md-settings-grey.png"
                        @click="PrikazUrejanjaEmaila">
                  </el-form-item>
                  <el-form-item label="Kontaktna oseba:" v-else>
                    <el-input v-model="emailIzbraneVrsticeZaUrejanje" class="velikost-input">
                    </el-input>
                    <el-button @click="SpremeniEmail(scope.row.idPanda)" class="gumb-potrdi">
                      SHRANI
                    </el-button>
                    <a class="stil-gumb-preklici" @click="PrikazUrejanjaEmaila"
                       type="primary">
                      PREKLIČI
                    </a>
                  </el-form-item>
                  <el-form-item label="Nakup opravil:">
                    {{ scope.row.narocil }}
                  </el-form-item>
                </el-form>
                <div>
                  <div>
                    <div class="flex-container">
                      <div>
                        <a :href=scope.row.file>
                          <el-button class="okvir-povezave tekst-povezave" style="cursor: pointer">
                            PONOVNI PRENOS PROGRAMSKE OPREME
                          </el-button>
                        </a>
                      </div>
                      <div>
                          <span>
                            <span style="float: left">
                              <img src="/static/img/Domov/Icon-awesome-exclamation-triangle-black.png" sizes="20">
                            </span>
                          </span>
                        <div style="padding-left: 20px">
                          <p class="navadno-besedilo">
                            <b>
                              POZOR! Aktivacijsko kodo ste prejeli na kontaktni e-naslov.
                            </b>
                            <span class="samostojna-vrstica">
                            V primeru, da želite pridobiti kopijo licenčne kode, nam prosimo pišite na
                            <a href="" class="primarna-barva">
                              {{ kontaktniPodatki.T2_INFO_EMAIL }}
                            </a>.
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="clear: both"/>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-show="prikazTabele === '0'">
        <el-table :data="seznamNarocenihLicenc"
                  :row-key="row => row.idPanda"
                  :expand-row-keys="expandRowKeys"
                  @expand-change="IzbiraVrsticeZaPrikazPodatkov">
          <el-table-column
            prop="naziv"
            label="Tip licence">
          </el-table-column>
          <el-table-column width="200px">
            <template slot-scope="scope">
              <OrderButton
                @orderConfirmed="OsveziPodatke()"
                :services="[{
                      serviceId: scope.row.idStoritevVrstaIzbira,
                      quantity: 0,
                      terminationPointId: Number.parseInt(izbranPrikljucek),
                      additionalData: [{key: 'pandaId', value: scope.row.idPanda}]
                    }]"
                class="inline-button"
                :service-name="scope.row.naziv">
                <template slot="buttonOverride">
                  <a style="color: #080809">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev/Icon-awesome-trash-alt.png">
                    <b>
                      ODJAVI LICENCO
                    </b>
                  </a>
                </template>
              </OrderButton>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="padding-top: 20px">
                <el-form label-width="155px" :label-position="formaOrientacija">
                  <el-form-item label="Količina:" v-if="urejanjeKolicine.indexOf(scope.row.idPanda) === -1">
                    {{ scope.row.kolicina }}
<!--                    <img-->
<!--                      style="cursor: pointer"-->
<!--                      src="/static/img/dashboard/Icon-ionic-md-settings-grey.png"-->
<!--                      @click="PrikazUrejanjeKolicine(scope.row.idPanda)">-->
                  </el-form-item>
                  <el-form-item label="Količina:" v-else>
                    <el-input v-model="kolicinaIzbraneVrstice" class="velikost-input">
                    </el-input>
                    <OrderButton
                      @orderConfirmed="OsveziPodatke()"
                      :services="[{
                        serviceId: scope.row.idStoritevVrstaIzbira,
                        quantity: kolicinaIzbraneVrstice,
                        terminationPointId: Number.parseInt(izbranPrikljucek),
                        additionalData: [{key: 'pandaId', value: scope.row.idPanda}]
                      }]"
                      class="inline-button"
                      :service-name="'spremembo količine za naročeno storitev' + scope.row.naziv">
                      <template slot="buttonOverride">
                        <div class="stil-gumb-preklici">
                          <el-button type="primary" class="gumb-potrdi">
                            SHRANI
                          </el-button>
                        </div>
                      </template>
                    </OrderButton>
                    <a class="stil-gumb-preklici" @click="PrikazUrejanjeKolicine(scope.row.idPanda)"
                       type="primary">
                      PREKLIČI
                    </a>
                  </el-form-item>
                  <el-form-item label="Datum nakupa:">
                    {{ scope.row.formatiranDatum}}
                  </el-form-item>
                  <el-form-item label="Kontaktna oseba:" v-if="urejanjeEmaila === false">
                    {{ scope.row.email }}
                    <img src="/static/img/dashboard/Icon-ionic-md-settings-grey.png" @click="PrikazUrejanjaEmaila">
                  </el-form-item>
                  <el-form-item label="Kontaktna oseba:" v-else>
                    <el-input v-model="emailIzbraneVrsticeZaUrejanje" class="velikost-input">
                    </el-input>
                    <el-button @click="SpremeniEmail(scope.row.idPanda)" class="gumb-potrdi">
                      SHRANI
                    </el-button>
                    <a class="stil-gumb-preklici" @click="PrikazUrejanjaEmaila"
                       type="primary">
                      PREKLIČI
                    </a>
                  </el-form-item>
                  <el-form-item label="Nakup opravil:">
                    {{ scope.row.narocil }}
                  </el-form-item>
                </el-form>
                <div>
                  <div>
                    <div class="flex-container">
                      <div>
                        <a :href=scope.row.file>
                          <el-button class="okvir-povezave tekst-povezave" style="cursor: pointer">
                            PONOVNI PRENOS PROGRAMSKE OPREME
                          </el-button>
                        </a>
                      </div>
                      <div>
                          <span>
                            <span style="float: left">
                              <img src="/static/img/Domov/Icon-awesome-exclamation-triangle-black.png" sizes="20">
                            </span>
                          </span>
                        <div style="padding-left: 20px">
                          <p class="navadno-besedilo">
                            <b>
                              POZOR! Aktivacijsko kodo ste prejeli na kontaktni e-naslov.
                            </b>
                            <span class="samostojna-vrstica">
                            V primeru, da želite pridobiti kopijo licenčne kode, nam prosimo pišite na
                            <a href="" class="primarna-barva">
                              {{ kontaktniPodatki.T2_INFO_EMAIL }}
                            </a>.
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="clear: both"/>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {StoritevVrstaEnum} from '../../../../../assets/js/Enum/StoritevVrstaEnum.js'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import InfoKomponentaVarnostnaZascita from './InfoKomponentaVarnostnaZascita'
import {
  Table,
  TableColumn,
  InputNumber,
  Col,
  Button,
  MessageBox,
  Dialog,
  Input,
  Option,
  Checkbox,
  Form,
  FormItem,
  Steps,
  Step,
  Icon
} from 'element-ui'
import {KontaktniPodatkiEnum} from '../../../../../assets/js/Enum/KontaktniPodatkiEnum.js'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {StoritveOpisFormat} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StoritveOpisFormat'
import InfoKomponentaOpisPandaPaketa from './InfoKomponentaOpisPandaPaketa'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'
import Validacija from '../../../../../assets/js/globalne_funkcije/Validacija'
import OrderButton from '../../../../UIComponents/OrderButton.vue'

export default {
  name: 'ZascitaVarnostna',
  mixins: [SirinaOkna, StoritevVrstaEnum, PrikazVsebine, StoritveOpisFormat, FormatDatuma],
  data () {
    return {
      seznamZascitaVarnost: [],
      varnostniPaketPanda: '',
      steviloLicenc: 1,
      kontaktniPodatki: '',
      idStranka: '',
      vpisanEnaslov: '',
      pridobivanjeSezanamLicenc: false,
      izbranaidStoritevVrstaIzbira: '',
      seznamNarocenihLicenc: [],
      expandRowKeys: [],
      centerDialogVisible: false,
      formLabelWidth: '120px',
      strinjamSeZpogoji: false,
      formaOrientacija: 'left',
      mejnaSirina: 700,
      emailIzbraneVrsticeZaUrejanje: '',
      kolicinaIzbraneVrstice: 0,
      urejanjeEmaila: false,
      urejanjeKolicine: [],
      poljeOpisov: [],
      steviloPaketov: null,
      nalaganjePaketovVarnostneZascite: false,
      prikazTabele: '1',
      mejnaSirinaTabela: 1000,
      documentUrl: '../static/documents/licencna-pogodba-za-koncnega-uporabnika.pdf',
      documentUrlPosebenDogovor: '../static/documents/posebni-dogovor-panda.pdf',
      active: 0,
      validacija: null,
      narociPandaGumb: true,
      kolicinaZaNarocanje: 1,
      emailUporabnika: ''
      // numbers: Array.from({ length: 10 }, (_, i) => i + 1)
    }
  },
  watch: {
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.GetSeznamVarnostnaZascita()
      }
    }
  },
  props: {
    izbranPrikljucek: null,
    seznamNarocenaZascita: null,
    seznamVkloplenaZascita: null
  },
  components: {
    OrderButton,
    InfoKomponentaOpisPandaPaketa,
    InfoKomponentaVarnostnaZascita,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Col.name]: Col,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Input.name]: Input,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [InputNumber.name]: InputNumber,
    [Steps.name]: Steps,
    [Step.name]: Step,
    [Icon.name]: Icon
  },
  mounted () {
    this.validacija = new Validacija()
    this.clientAgent = new ClientAgent()
    this.varnostniPaketPanda = povezave.BASE_URL_VARNOSTNI_PAKET_PANDA
    this.kontaktniPodatki = KontaktniPodatkiEnum
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
    })
    this.GetSeznamVarnostnaZascita()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    OsveziPodatke () {
      this.Naroceno()
    },
    PreverjanjeEnaslova () {
      if (!this.validacija.EmailValid(this.vpisanEnaslov)) {
        this.narociPandaGumb = true
      } else {
        this.narociPandaGumb = false
      }
    },
    PreverjanjeEnaslovaMessage () {
      if (this.narociPandaGumb) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Prosimo, vpišite vaš elektronski naslov.'
        this.ShowWarningMessage(paramObvestilo)
      }
    },
    next () {
      switch (this.active) {
        case 0: this.active = 1
          break
        case 1: this.active = 2
          break
        default: this.active = 0
      }
    },
    PrikazUrejanjaEmaila () {
      this.urejanjeEmaila = this.urejanjeEmaila !== true
    },
    PrikazUrejanjeKolicine (id) {
      let index = this.urejanjeKolicine.indexOf(id)
      if (index === -1) {
        this.urejanjeKolicine.push(id)
      } else {
        this.urejanjeKolicine.splice(index, 1)
      }
    },
    IzbiraVrsticeZaPrikazPodatkov (row) {
      this.emailIzbraneVrsticeZaUrejanje = ''
      this.kolicinaIzbraneVrstice = 0
      const id = row.idPanda
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
      this.emailIzbraneVrsticeZaUrejanje = row.email
      this.kolicinaIzbraneVrstice = Number.parseInt(row.kolicina)
    },
    IzbranPaket (posamezenPaketZascitaVarnost) {
      this.active = 0
      this.centerDialogVisible = true
      this.izbranaidStoritevVrstaIzbira = ''
      this.izbranaidStoritevVrstaIzbira = posamezenPaketZascitaVarnost.idStoritevVrstaIzbira
    },
    PridobivanjeStrank () {
      let param = ['permissionId=PRIKLJUCKI']
      param.push('filter[id_prikljucek]=' + this.izbranPrikljucek)
      this.clientAgent.postWsRequest(this,
        'permissions/havePermission?',
        param,
        null,
        'SetStranke',
        'ErrStranke')
    },
    SetStranke (podatki) {
      this.idStranka = ''
      for (let i = 0; i < podatki.permission.additionalData.length; i++) {
        this.idStranka = podatki.permission.additionalData[i].id_stranka
      }
      this.Naroceno()
    },
    ErrStranke (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetSeznamVarnostnaZascita () {
      if (this.izbranPrikljucek !== '') {
        this.nalaganjePaketovVarnostneZascite = true
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('idVrsta[]=' + StoritevVrstaEnum.NAJEM_PROGRAMSKE_OPREME)
        this.clientAgent.postWsRequest(
          this,
          'panda/seznamStoritev',
          param,
          null,
          'SetSeznamVarnostnaZascita',
          'ErrSeznamVarnostnaZascita')
      }
    },
    SetSeznamVarnostnaZascita (podatki) {
      this.seznamZascitaVarnost = []
      this.seznamZascitaVarnost = podatki.data
      this.seznamZascitaVarnost = this.PridobiSeznamOpisov(this.seznamZascitaVarnost)
      this.PridobivanjeStrank()
      this.steviloPaketov = this.seznamZascitaVarnost.length
      this.nalaganjePaketovVarnostneZascite = false
    },
    ErrSeznamVarnostnaZascita (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.nalaganjePaketovVarnostneZascite = false
    },
    SpremeniEmail (idPanda) {
      if (this.izbranPrikljucek !== '') {
        let param = ['idPandaUser=' + idPanda]
        param.push('email=' + this.emailIzbraneVrsticeZaUrejanje)
        this.clientAgent.postWsRequest(
          this,
          '/panda/spremeniEmail',
          param,
          null,
          'SetSpremeniEmail',
          'ErrSpremeniEmail')
      }
    },
    SetSpremeniEmail (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno spremenjen email.'
      this.ShowSuccessMessage(paramObvestilo)
      this.Naroceno()
      this.urejanjeEmaila = false
    },
    ErrSpremeniEmail (podatki) {
      this.ShowWarningMessage(podatki)
      this.urejanjeEmaila = true
    },
    Remove (idPanda, izbranaLicenca) {
      let date1 = new Date()
      let date2 = new Date(izbranaLicenca.trajanjeOd)
      if (date1 - date2 > 2 * 60 * 1000) {
        MessageBox.confirm('Ali ste prepričani, da želite odjaviti licenco?',
          {
            confirmButtonText: 'Da',
            cancelButtonText: 'Prekliči',
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonClass: 'gumb-preklici',
            customClass: 'opozorilo-dialog'
          }).then(() => {
          let param = ['idPandaUser=' + idPanda]
          this.clientAgent.postWsRequest(
            this,
            'panda/preklici?',
            param,
            null,
            'SetRemove',
            'ErrRemove')
        }).catch((err) => {
          err = null
        })
      } else {
        MessageBox.alert('Izbrano licenco lahko odjavite dve minuti po nakupu.' +
          ' Prosimo, poskusite ponovno kasneje. ', {
          dangerouslyUseHTMLString: true,
          customClass: 'opozorilo-dialog',
          confirmButtonClass: 'gumb-potrdi'
        }).catch((err) => {
          err = null
        })
      }
    },
    SetRemove (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Licenca uspešno odjavljena.'
      this.ShowSuccessMessage(paramObvestilo)
      this.Naroceno()
    },
    ErrRemove (podatki) {
      this.ShowWarningMessage(podatki)
    },
    Vklop () {
      this.centerDialogVisible = false
      if (this.izbranPrikljucek !== '') {
        if (this.validacija.EmailValid(this.vpisanEnaslov)) {
          let param = ['idPrikljucek=' + this.izbranPrikljucek]
          // let param = ['idStoritevVrstaIzbira=' + this.izbranaidStoritevVrstaIzbira]
          param.push('idStoritevVrstaIzbira=' + this.izbranaidStoritevVrstaIzbira)
          param.push('email=' + this.vpisanEnaslov)
          param.push('kolicina=' + this.steviloLicenc)
          this.clientAgent.postWsRequest(
            this,
            'panda/vklopi?',
            param,
            null,
            'SetVklop',
            'ErrVklop')
        } else {
          let paramObvestilo = {}
          paramObvestilo.message = 'Napačen format email naslova.'
          this.ShowWarningMessage(paramObvestilo)
        }
      }
    },
    SetVklop () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Naročilo uspešno izvedeno. Želimo vam prijetno uporabo!'
      this.ShowSuccessMessage(paramObvestilo)
      this.Naroceno()
    },
    ErrVklop (podatki) {
      this.ShowWarningMessage(podatki)
    },
    Naroceno () {
      if (this.izbranPrikljucek !== '') {
        this.pridobivanjeSezanamLicenc = true
        let param = ['idStranka=' + this.idStranka]
        this.clientAgent.postWsRequest(
          this,
          'panda/naroceno?',
          param,
          null,
          'SetNaroceno',
          'ErrNaroceno')
      }
    },
    SetNaroceno (podatki) {
      this.seznamNarocenihLicenc = []
      this.seznamNarocenihLicenc = podatki.data
      for (let i = 0; i < this.seznamNarocenihLicenc.length; i++) {
        let izpisFormatDatuma = this.PoenotenIzgledDatuma(this.seznamNarocenihLicenc[i].trajanjeOd)
        this.seznamNarocenihLicenc[i].formatiranDatum = izpisFormatDatuma
      }
      this.pridobivanjeSezanamLicenc = false
    },
    ErrNaroceno (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.pridobivanjeSezanamLicenc = false
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociInternet/VarnostnaZascita.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociInternet/ZascitaVarnostna.vue